<script lang="ts">
  import {getContext, onDestroy, onMount} from 'svelte';
  import {PATHS} from '@/const/paths';
  import {popupUtil} from '@/helper/popup';
  import {sd} from '@/da/sd';
  import {SERVICES} from '@/const/services';
  import {fixLink$} from '@/store/lang';
  import {checkTarget, isEmpty, loginCheck, maskDialog$, passKeyClickEvent$} from './PasskeyLogin';
  import Button from '../../../../widgets/Button.svelte';
  import PasskeyVerificationDialog from '../../popups/PasskeyVerificationDialog.svelte';
  import lang from '../../LoginPage.lang';
  import MaskDialog from '@/modules/account/security/components/bind-passkeys/MaskDialog.svelte';

  export let email: string;
  export let isInitializing: boolean = true;
  export let isLoading: boolean = false;
  export let hasErrorMsg: boolean = false;
  export let target: string;
  export let onStatusChange: (p) => void;
  export let LG = getContext('LG');

  const passkeyIcon = `${SERVICES.IMG_URL}/v1/081e54cb-8dd3-4a75-8a76-1d229f0ddb46/login-passkey.png`;

  let tryCount = 0;
  let isShowPasskeyDesc = false;
  let maksDialog;
  let subscription;
  let maskSubscription;

  onMount(() => {
    subscription = passKeyClickEvent$.subscribe((d) => {
      if (d.event) {
        handleButtonNextClick();
      }
    });

    maskSubscription = maskDialog$.subscribe((v) => {
      if (v.visible) {
        maksDialog = popupUtil.create(MaskDialog);
      } else {
        maksDialog?.$destroy();
      }
    });
  });

  onDestroy(() => {
    subscription?.unsubscribe();
    maskSubscription?.unsubscribe();
  });

  function handleStatusChange(p) {
    const {isShowPasskeyDesc: isShow, ...rest} = p;
    if (!isEmpty(isShow)) {
      isShowPasskeyDesc = isShow;
    }
    onStatusChange?.(rest);
  }

  async function handleButtonNextClick() {
    sd.track('launch_passkey_login', {ui_position: 'login_page'});
    if (email && !hasErrorMsg) {
      handleStatusChange({isLoading: true});
      const pathName = checkTarget(target) ? target : $fixLink$(PATHS.ACCOUNT_OVERVIEW.pathname);
      loginCheck({email, pathName, LG, onStatusReset: handleStatusChange, onShowDialog: showVerificationFailedDialog});
    }
  }

  function showVerificationFailedDialog() {
    if (tryCount >= 3) {
      handleStatusChange({isLoading: false, isShowPasskeyDesc: false, isOpenPasskey: false});
      return;
    }
    const dialog = popupUtil.create(PasskeyVerificationDialog, {LG});
    return new Promise((resolve) => {
      dialog.$on('success', function (event) {
        dialog.$destroy();
        resolve(event.detail);
        const {type} = event.detail;
        if (type === 'once') {
          // once login again
          tryCount++;
          handleButtonNextClick();
          return;
        }
        // pwd login
        handleStatusChange({isLoading: false, isShowPasskeyDesc: false, isOpenPasskey: false});
      });
      dialog.$on('close', function () {
        handleStatusChange({isLoading: false, isShowPasskeyDesc: false});
        resolve(null);
      });
    });
  }
</script>

<style lang="scss">
  .passkey {
    padding: 14px 20px;
    font-family: 'HarmonyOs Sans';
    background-color: #f1f4f9;
  }
  .btn :global(button.primary) {
    background: var(--BTN-BG);
    color: var(--BTN-COLOR);
    border-color: var(--BTN-BG);
  }
</style>

<div>
  {#if isShowPasskeyDesc}
    <div class="df aic passkey br8 mt20">
      <span class="mr4">
        <img width="36" height="36" src={passkeyIcon} />
      </span>
      <div>
        <div class="f14 fw3 lh20 T1">{LG(lang.PasskeyTitle)}</div>
        <div class="f12 fw1 lh18 mt4 T2">{LG(lang.PasskeyDesc)}</div>
      </div>
    </div>
  {/if}
  <div class="btn">
    <Button class="mt20 pr f16 fw3 br48" type="primary" newRadius minWidth="100%" on:click={handleButtonNextClick} loading={isLoading} disabled={isInitializing || hasErrorMsg}
      >{LG(isInitializing ? lang.Initializing : lang.PasskeyNext)}</Button
    >
  </div>
</div>
